import algoliasearch from "algoliasearch/lite";
import environment from "../../environment";

let searchClient;

// Simple environment detection for Algolia
const isLocalhost = window.location.hostname === "localhost";

if (environment.name === "production") {
  searchClient = algoliasearch(
    "PQZREHRAC5",
    "2615264427a091c36b6101121bf1027e"
  );
} else if (environment.name === "staging") {
  if (isLocalhost) {
    // Use dev Algolia when running locally (same keys you used before)
    searchClient = algoliasearch(
      "Y3KICFA7UD",
      "d9b30416a7af07d3fadacc3ebcdea441"
    );
  } else {
    // Use staging Algolia when deployed to staging
    searchClient = algoliasearch(
      "M6J5C1TXKI",
      "dd29714e7fd8a06c6fb5b92b2758dd9d"
    );
  }
} else {
  console.error(`Unknown environment: ${environment.name}`);
  throw new Error(
    `Invalid environment configuration: ${environment.name}. Must be 'staging' or 'production'.`
  );
}

export default searchClient;
